import React from 'react'
import { IssuingCardReloadContent } from './issuingCardReloadcontent'

export const IssuingCardReload = () => {
  return (
    <IssuingCardReloadContent />
  )
}
